import React from 'react';
import AboutHero from '../components/About/AboutHero';
import AboutIntro from '../components/About/AboutIntro';
import OurStory from '../components/About/OurStory';
import WhatWeDo from '../components/About/WhatWeDo';
import OurApproach from '../components/About/OurApproach';
import Partnerships from '../components/About/Partnerships';
import OurValues from '../components/About/OurValues';
import OurTeam from '../components/About/OurTeam';
import Compliance from '../components/About/Compliance';
import WhyIvipass from '../components/About/WhyIvipass';
import CTASection from '../components/About/CTASection';

const AboutUs = () => {
  return (
    <div>
      <AboutHero />
      <AboutIntro />
      <OurStory />
      <WhatWeDo />
      <OurApproach />
      <Partnerships />
      <OurValues />
      <OurTeam />
      <Compliance />
      <WhyIvipass />
      <CTASection />
    </div>
  );
};

export default AboutUs;

